import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { responsive } from '../utils/layout'
import { getInnerWidth } from '../helpers/device'

export const Responsive = ({ children, renderResponsive }) => {
  const [reRender, setReRender] = useState(false)

  useEffect(() => {
    const resize = () => {
      setReRender(!reRender)
    }
    window.addEventListener('resize', resize)

    return () => {
      window.removeEventListener('resize', resize)
    }
  }, [reRender])

  if (getInnerWidth() < responsive.PIVOT_WIDTH) {
    return renderResponsive()
  }

  return children
}

Responsive.propTypes = {
  children: PropTypes.node,
  renderResponsive: PropTypes.func,
}

Responsive.defaultProps = {
  children: null,
  renderResponsive: () => {},
}
